
import { computed, defineComponent, ref, Ref, toRef, watch } from 'vue';
import { Field } from 'vee-validate';
import { CustomInputFieldInternalValue } from '@/shared/form/validation.plugin';

export default defineComponent({
    name: 'InputCheckbox',
    components: { Field },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Object, Boolean, Number],
            default: true,
        },
        // eslint-disable-next-line vue/require-default-prop
        modelValue: {
            type: null,
        },
        showErrors: {
            type: Boolean,
            default: true,
        },
        rules: {
            type: String,
            default: '',
        },
    },
    emits: {
        'update:modelValue': (value) => true,
        change: (value) => true,
    },
    setup(props, { emit }) {
        const internalValue: Ref<CustomInputFieldInternalValue> = ref(null);
        const fieldId = computed(() => {
            return props.id || props.name + Math.random();
        });

        const isModelBound = computed(() => {
            return 'modelValue' in props;
        });

        const fieldRules = computed(() => props.rules);

        if (isModelBound.value) {
            const modelValue = toRef(props, 'modelValue');
            watch(modelValue, newModelValue => {
                if (newModelValue !== internalValue.value) {
                    internalValue.value = newModelValue;
                }
            }, { immediate: true });
            watch(internalValue, newInternalValue => {
                emit('update:modelValue', newInternalValue);
            });
        } else {
            watch(internalValue, newInternalValue => {
                emit('change', newInternalValue);
            });
        }

        return {
            fieldId,
            internalValue,
            fieldRules,
        };
    },
});
